import { createFileRoute, redirect } from "@tanstack/react-router";

// This route is a catch-all route for the settings page
// It redirects to the general settings page
export const Route = createFileRoute("/_secure/settings/$")({
  beforeLoad: () => {
    throw redirect({ to: "/settings", search: {} }); // eslint-disable-line @typescript-eslint/only-throw-error
  },
});
